import { useEffect, useState } from "react";
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "../../../../../components";
import { TagsService, GrupoProdutosService } from "../../../../../services";
import { responseErros } from "../../../../../utils";
import { InputErros, value } from "../../../../../helpers";

const grupoProdutosService = new GrupoProdutosService();
const tagsService = new TagsService();

const FiltrosConsultaFiscalStep = ({
  filtros,
  setFiltros,
  filtrarTodosProdutos,
  setFiltrarTodosProdutos,
}) => {
  const [grupoProdutoList, setGrupoProdutoList] = useState([]);
  const [tags, setTags] = useState([]);
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);

  const buscarGruposProduto = () => {
    const filtros = {
      nonPaginated: true,
    };
    grupoProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setGrupoProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarTags = async function () {
    const filtros = {
      nonPaginated: true,
      ativado: true,
      tipo: "PRODUTO",
    };
    const result = await tagsService.getAll(filtros);
    if (!result.isAxiosError) {
      setTags(result.data);
    } else {
      responseErros(result);
    }
  };

  const onChangeAutocomplete = (id, value) => {
    setFiltros({
      ...filtros,
      [id]: value ? value.id : undefined,
    });
  };

  const handleChangeCheckbox = (event) => {
    if (event.target.checked) {
      setFiltros({});
    }
    setFiltrarTodosProdutos(event.target.checked);
  };

  useEffect(() => {
    buscarGruposProduto();
    buscarTags();
  }, []);

  const onChangeMultiple = (valores, name) => {
    if (!valores?.length) {
      resetarFiltros(name);
      return;
    }
    setFiltros((prevState) => ({
      ...prevState,
      [name]: valores.map(({ id }) => id),
    }));
  };

  function resetarFiltros(name) {
    setFiltros((prevState) => {
      const prevStateTemp = { ...prevState };
      delete prevStateTemp[name];
      return prevStateTemp;
    });
  }

  return (
    <Grid container spacing={2} columns={13}>
      <Grid item xs={5}>
        <Autocomplete
          id="grupoProdutoId"
          name="grupoProdutoId"
          options={grupoProdutoList}
          noOptionsText="Sem opções"
          autoHighlight
          getOptionLabel={(option) => (option ? option.descricao : "")}
          disabled={filtrarTodosProdutos}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Grupo de Produto"
              variant="outlined"
              margin="normal"
              disabled={filtrarTodosProdutos}
              error={inputErros.get("grupoProdutoId")}
            />
          )}
          onChange={(_, newValue) => {
            setInputErro([]);
            onChangeAutocomplete("grupoProdutoId", newValue);
          }}
          value={value.autoComplete(grupoProdutoList, filtros?.grupoProdutoId)}
        />
      </Grid>
      <Grid item xs={5}>
        <Autocomplete
          multiple
          id="tagsId"
          name="tagsId"
          options={tags}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => {
            return (
              <div>
                <i
                  className="ph-fill ph-bookmark-simple"
                  style={{ color: `${option?.cor}`, marginRight: "10px" }}
                ></i>
                {option?.descricao}
              </div>
            );
          }}
          onChange={(_, newValue) => onChangeMultiple(newValue, "tagsId")}
          value={value.multiple(tags, filtros?.tagsId)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              required
              margin="normal"
              label="Tags"
            />
          )}
        />
      </Grid>
      <Grid item xs={3} alignContent="center" alignItems="center">
        <FormControlLabel
          label="Filtrar todos Produtos"
          control={
            <Checkbox
              id="filtrarTodosProdutos"
              name="filtrarTodosProdutos"
              checked={filtrarTodosProdutos}
              onChange={handleChangeCheckbox}
              color="primary"
            />
          }
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosConsultaFiscalStep;
